import React from 'react'
import Link from 'gatsby-link'
import Scrollchor from 'react-scrollchor';

const ScrollLink = props =>

    <li>
        {/* <Link className="c-btn--link" to={props.to}>
                {props.children}
            </Link> */}
        <Scrollchor className="c-btn--link" to={props.to} animate={props.animate} >{props.children}</Scrollchor>
    </li>


export default ScrollLink



// WEBPACK FOOTER //
// ./src/components/scroll-link.js